import { definePreset } from '@primeng/themes'
import Aura from '@primeng/themes/aura'

/**
 * Hema brand preset for PrimeNG. The primary ramp is anchored on the GRC
 * redesign indigo `--grc-primary` (#474C9E, see assets/theme/grc/_tokens.scss);
 * surrounding shades are a tonal scale around it so themed PrimeNG components
 * match the UI instead of Aura's default blue. The preset is static at boot and
 * shared by both themes — classic's #4e57a1 anchor differs imperceptibly, so
 * runtime preset swapping isn't worth it.
 *
 * The theme is registered with a `cssLayer` (see app.module.ts) so PrimeNG's
 * styles sit in the lowest-priority CSS layer — every existing unlayered custom
 * style (table ::ng-deep overrides, Bootstrap) keeps winning, so this does not
 * restyle the already-customised tables. It only supplies a styled baseline for
 * components that had no custom CSS (e.g. pTooltip, and p-select in Phase 3).
 */
export const HemaPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#edeff9',
      100: '#dadcf0',
      200: '#b5b9e1',
      300: '#8f96d1',
      400: '#6a6fb9',
      500: '#474c9e',
      600: '#3f438d',
      700: '#363a79',
      800: '#2c2f63',
      900: '#232551',
      950: '#171833'
    }
  }
})
